import React, { Component } from 'react';

import './WhatsappButton.css';

class WhatsappButton extends Component {

  render() {
    return (
      <a rel="noopener noreferrer" href="https://api.whatsapp.com/send?phone=13053438780&text=Hola%2C%20quiero%20obtener%20informaci%C3%B3n" target="_blank">
        <div className="whatsapp-button">
          <i className="fab fa-whatsapp"></i>
        </div>
      </a>
    );
  }
}

export default (WhatsappButton);



// WEBPACK FOOTER //
// ./src/components/WhatsappButton/WhatsappButton.js